import { DeviceOption } from 'src/app/pages/phones/models/device-option.interface';

export function twoFieldOptionFilter(types: DeviceOption[], searchText: string | null | undefined): DeviceOption[] {
   if (types.length === 0) {
      return [];
   }
   const term = searchText && searchText.trim();
   if (term) {
      const normalizedSearchText = term.replace(/\s+/g, '');
      const upper = normalizedSearchText.toUpperCase();
      return types.filter((item) => {
         return (
            (item.deviceTypeId && item.deviceTypeId.replace(/\s+/g, '').toUpperCase().includes(upper)) ||
            (item.macAddress && item.macAddress.replace(/\s+/g, '').toUpperCase().includes(upper))
         );
      });
   } else {
      return types || [];
   }
}
